<template>
  <v-container pa-0 fill-height>
    <v-row no-gutters justify="center" align="center" class="fill-height">
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <v-col cols="auto" style="position: relative;">
            <v-progress-circular
                ref="pulse"
                style="position: absolute;"
                color="white"
                :width="5"
                :size="700"
                :value="100"
            >
            </v-progress-circular>
            <v-progress-circular
                style="position: absolute;"
                color="primary"
                :width="10"
                :size="700"
                :value="100"
            >
            </v-progress-circular>
            <v-progress-circular
                color="white"
                rotate="-90"
                :width="10"
                :size="700"
                :value="timePerc"
            >
              <div class="white--text select-none font-weight-light text-center"
                   style="transition: all 0.5s ease-in-out; user-select: none; min-width: 650px;"
                   :style="secondsOnly || !timeText ? 'font-size: 400px;' : 'font-size: 100px;'"
              >{{ !!timeText ? timeText : 0 }}
              </div>
            </v-progress-circular>
          </v-col>
        </v-row>
        <v-row dense justify="center" class="mt-6">
          <v-col cols="auto">
            <v-btn
                outlined
                class="rounded-lg"
                color="white"
                @click="cancel()"
            >{{ timeLeft > 0 ? 'Cancel' : 'Back' }}
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="canRestart">
            <v-btn
                outlined
                class="rounded-lg"
                color="white"
                @click="restart()"
            >Restart
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UrlParserMixin from "@/mixins/UrlParserMixin";

export default {
  name: "TimerCounter",
  mixins: [UrlParserMixin],
  props: {
    time: {
      type: Number,
      required: true,
    },
    direction: {
      type: String,
      default: 'up',
    },
  },
  computed: {
    getTime() {
      return this.time;
    },
    timePerc() {
      return (this.timeLeft / this.getTime) * 100;
    },
    canRestart() {
      if (this.direction === 'down') {
        return this.timeLeft === 0;
      } else if (this.direction === 'up') {
        return this.timeLeft === this.time;
      }

      return false;
    },
  },
  data: () => ({
    timeLeft: 0,
    timeText: '',
    timeInterval: null,
    animation: null,
    secondsOnly: false,
  }),
  methods: {
    playPulsesOnTime() {
      if (this.timeLeft === 60000) {
        this.playPulse();
      }

      if (this.timeLeft === 30000) {
        this.playPulse();
      }

      if (this.timeLeft <= 10000) {
        this.playPulse();
      }
    },
    playPulse() {
      const pulse = this.$refs.pulse.$el.style;

      if (pulse) {
        pulse.transition = 'all 0.8s';
        pulse.transform = 'scale(1.1)';
        pulse.opacity = '0';

        setTimeout(() => {
          pulse.transition = 'none';
          pulse.transform = 'scale(1)';
          pulse.opacity = '1';
        }, 900);
      }
    },
    initTime() {
      if (this.direction === 'down') {
        this.timeLeft = JSON.parse(JSON.stringify(this.time));
      } else if (this.direction === 'up') {
        this.timeLeft = 0;
      }
    },
    initTimeText() {
      this.setTimeText();
    },
    setTimeText() {
      this.secondsOnly = false;

      const seconds = Math.floor((this.timeLeft / 1000) % 60),
          minutes = Math.floor((this.timeLeft / (1000 * 60)) % 60),
          hours = Math.floor((this.timeLeft / (1000 * 60 * 60)) % 24);

      if ((this.direction === 'down' && this.timeLeft <= 0) || (this.direction === 'up' && this.timeLeft === this.time)) {
        this.timeText = 'Done!'
        clearInterval(this.timeInterval);
      } else {
        if (hours > 0) {
          this.timeText = `${hours}h ${minutes ? minutes + 'm' : '00m'} ${seconds ? seconds + 's' : '00s'}`;
        } else if (!hours && minutes > 0) {
          this.timeText = `${minutes + 'm'} ${seconds ? seconds + 's' : '00s'}`;
        } else if (!hours && !minutes && seconds > 0) {
          this.secondsOnly = true;
          this.timeText = `${seconds}`;
        }
      }
    },
    startTimerUp() {
      this.timeInterval = setInterval(() => {
        this.timeLeft += 1000;
        this.setTimeText();
      }, 1000);
    },
    startTimerDown() {
      this.timeInterval = setInterval(() => {
        this.timeLeft -= 1000;
        this.setTimeText();
        this.playPulsesOnTime();
      }, 1000);
    },
    cancel() {
      this.$emit('prev');
    },
    restart() {
      this.initTime();

      if (this.direction === 'up') {
        this.startTimerUp();
      } else if (this.direction === 'down') {
        this.startTimerDown();
      }
    },
  },
  mounted() {
    this.initTime();
    this.initTimeText();

    if (this.direction === 'up') {
      this.startTimerUp();
    } else if (this.direction === 'down') {
      this.startTimerDown();
    }
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
}
</script>

<style scoped>
</style>